<div class="flex flex-col bg-card overflow-hidden">
  <div class="light:bg-cool-gray-100 dark:bg-cool-gray-700 pl-3 pr-3 py-2 border-b flex items-center">
    <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
      <app-form-field [fieldDef]="titleFieldDef" [model]="property" (onUpdate)="update($event)"></app-form-field>
    </div>
    <div class="flex flex-col">
      <div *ngIf="!changeTitleMode" class="font-bold text-md text-secondary uppercase tracking-wider">
        {{ panelDef.title }}
      </div>
    </div>
    <div class="ml-auto" *ngIf="canEditPanelDef">
      <button mat-icon-button type="button" *ngIf="!changeTitleMode" [matMenuTriggerFor]="listCard09Menu">
        <mat-icon class="icon-size-20" [svgIcon]="'more_vert'"></mat-icon>
      </button>
      <mat-menu #listCard09Menu="matMenu">
        <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
          <mat-icon [svgIcon]="'edit'"></mat-icon>
          Change Panel Heading
        </button>
      </mat-menu>
      <button
        class="cancel-button"
        mat-icon-button
        type="button"
        *ngIf="changeTitleMode"
        [matTooltip]="'Cancel'"
        (click)="cancelEdits()"
      >
        <mat-icon [svgIcon]="'cancel'"></mat-icon>
      </button>

      <!-- Save button -->
      <button mat-icon-button *ngIf="changeTitleMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
        <mat-icon [svgIcon]="'save'"></mat-icon>
      </button>
    </div>
  </div>
  @if (newTable) {
  <ts-table [columnDefs]="columnDefs" [rowData]="unitLeaseDataSource.data"> </ts-table>
  } @else {
  <table mat-table [dataSource]="unitLeaseDataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">
        <a [routerLink]="['/properties/' + property.id + '/leases/' + element.id]">{{ element.name }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="usps_fin_sub">
      <th mat-header-cell *matHeaderCellDef>USPS Fin Sub</th>
      <td mat-cell *matCellDef="let element">{{ element.usps_fin_sub }}</td>
    </ng-container>

    <ng-container matColumnDef="lease_start_date">
      <th mat-header-cell *matHeaderCellDef>Lease Start Date</th>
      <td mat-cell *matCellDef="let element">{{ element.lease_start_date }}</td>
    </ng-container>

    <ng-container matColumnDef="lease_end_date">
      <th mat-header-cell *matHeaderCellDef>Lease End Date</th>
      <td mat-cell *matCellDef="let element">{{ element.lease_end_date }}</td>
    </ng-container>

    <ng-container matColumnDef="annual_rent">
      <th mat-header-cell *matHeaderCellDef>Annual Rent</th>
      <td mat-cell *matCellDef="let element">{{ element.annual_rent }}</td>
    </ng-container>

    <ng-container matColumnDef="maintenance">
      <th mat-header-cell *matHeaderCellDef>Maintenance</th>
      <td mat-cell *matCellDef="let element">{{ element.maintenance }}</td>
    </ng-container>

    <ng-container matColumnDef="interior_sq_ft">
      <th mat-header-cell *matHeaderCellDef>Int SqFt</th>
      <td mat-cell *matCellDef="let element">{{ element.interior_sq_ft }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
  </table>
  }
</div>
